import React, { useMemo } from 'react';
import { useActionModal } from '../../modules/actionModal';
import { useNavigate, useParams } from 'react-router-dom';
import { useSuspense } from 'rest-hooks';
import { useScoreModel } from '../../model/context/scoreModelContext';
import { PolicyRuleResource } from '../../model/resources/policyRuleResource';
import { PolicyRule } from '../../model/interfaces/policyRule';
import { ActiveRules } from './modules/activeRules';
import { DynamicInputBlock } from '../scoremodel/modules/dynamicInputBlock';
import { CreatingNewRuleProps } from './rulesPage';

export const Rules = ({ isCreatingNewRule, setIsCreatingNewRule, showAllRules, setShowAllRules, hasUnsavedChanges, setHasUnsavedChanges}: CreatingNewRuleProps) => {

  const { openActionModal } = useActionModal();
  const navigate = useNavigate();
  const { ruleid } = useParams();
  const { scoreModel} = useScoreModel();
  const allRules = useSuspense(PolicyRuleResource.list());

  const rules = useMemo(
    () => (showAllRules ? allRules : scoreModel?.policyRules ?? []),
    [showAllRules, allRules, scoreModel?.policyRules]
  );

  const selectedRuleId = useMemo(
    () => (Number.isNaN(Number(ruleid)) ? undefined : Number(ruleid)),
    [ruleid]
  );

  const selectedRule = useMemo(
    () => rules.find((rule: PolicyRule) => rule.policyRuleId === selectedRuleId) ?? null,
    [rules, selectedRuleId]
  );

  const addNewRule = () => {
    setIsCreatingNewRule(true);
    navigate(`/rules/new`, { replace: true });
  };

  const selectRule = (rule: PolicyRule) => {
    setIsCreatingNewRule(false);
    navigate(`/rules/${rule.policyRuleId}`, { replace: true });
  };

  //Add new Rule
  const requestAddNew = () => {
    if (hasUnsavedChanges) {
      openActionModal(
        'Unsaved changes',
        'You have unsaved changes, do you want to discard them?',
        'DiscardUnsavedChanges',
        'Cancel',
        () => addNewRule()
      );
    } else {
      addNewRule();
    }
  };

  //Select another Rule
  const requestSelectRule = (rule: PolicyRule) => {
    if (isCreatingNewRule || hasUnsavedChanges) {
      openActionModal(
        'Unsaved changes',
        'You have unsaved changes, do you want to discard them?',
        'DiscardUnsavedChanges',
        'Cancel',
        () => selectRule(rule)
      );
    } else {
      selectRule(rule);
    }
  };
  const AllRules =() =>  {
    return(
    <ActiveRules
      rules={rules}
      onAddNew={requestAddNew}
      onSelectRule={requestSelectRule}
      selectedRule={selectedRule}
      showAllRules={showAllRules}
      setShowAllRules={(value) => setShowAllRules(value)}
    />)
  }
  return (   <DynamicInputBlock LastComponent={AllRules} columnWidth={0.2} />);
};